import {runCatalogProductOperation} from './backend-api.js';

export function buildProductInput({title, description, template, variants, price, compareAtPrice, mockupUrls, handle, intentId}) {
  if (!handle || !intentId) throw new Error('Publish intent is missing.');
  const retailPrice = validateRetailPrice(price, template);
  const compareAt = validateCompareAtPrice(compareAtPrice, retailPrice);
  const colors = [...new Set(variants.map(({color}) => color))];
  const sizes = [...new Set(variants.map(({size}) => size))];
  return {
    title,
    handle,
    descriptionHtml: `<p>${escapeText(description || `${title} — made to order.`)}</p>`,
    productType: template.group || 'Apparel',
    vendor: 'Printew',
    status: 'ACTIVE',
    tags: ['pod', 'manual-fulfillment', `printew-intent:${intentId}`],
    productOptions: [
      {name: 'Size', values: sizes.map((name) => ({name}))},
      {name: 'Color', values: colors.map((name) => ({name}))},
    ],
    files: colors.map((color) => ({
      originalSource: mockupUrls[color],
      alt: `${title} in ${color.toLowerCase()}`,
      contentType: 'IMAGE',
    })),
    variants: variants.map((variant) => ({
      optionValues: [
        {optionName: 'Size', name: variant.size},
        {optionName: 'Color', name: variant.color},
      ],
      price: retailPrice.toFixed(2),
      compareAtPrice: compareAt,
      inventoryItem: {sku: variant.sku, tracked: false},
      file: {originalSource: mockupUrls[variant.color], contentType: 'IMAGE'},
    })),
  };
}

export async function createOrRecoverProduct(input, handle, operation = runCatalogProductOperation) {
  const result = await operation('create', {input, handle});
  if (!result?.product?.id) throw new Error('Product creation returned no confirmed Shopify product ID.');
  return result.product;
}

export async function publishProduct(productId, handle, operation = runCatalogProductOperation) {
  return operation('publish', {productId, handle});
}

export function validateRetailPrice(price, template) {
  const retailPrice = Number(price);
  const floor = Number(template.pricingRule?.floor || 1);
  if (!Number.isFinite(retailPrice) || retailPrice < floor) {
    throw new Error(`Retail price must be at least $${floor.toFixed(2)}.`);
  }
  return retailPrice;
}

export function validateCompareAtPrice(value, retailPrice) {
  if (value === '' || value === null || value === undefined) return undefined;
  const compareAtPrice = Number(value);
  if (!Number.isFinite(compareAtPrice) || compareAtPrice <= retailPrice) {
    throw new Error('Compare-at price must be higher than the retail price.');
  }
  return compareAtPrice.toFixed(2);
}

function escapeText(value) {
  return String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
}
